// Torggler - nový vzhled.
(function () {
	'use strict';

	// Našeptávač se ptá až od druhého znaku, aby jedno písmeno nevrátilo náhodných šest produktů.
	var SUGGEST_MIN_LENGTH = 2;
	var SUGGEST_DELAY = 200;

	// Křížek ve vyhledávání se zobrazuje vždy, když je v poli text; pod polem našeptávač produktů.
	function initSearch() {
		var search = document.querySelector('.tg-search');

		if (!search) {
			return;
		}

		var input = search.querySelector('.tg-search__input');
		var clear = search.querySelector('.tg-search__clear');

		if (!input || !clear) {
			return;
		}

		var panel = search.querySelector('[data-tg-suggest]');
		var url = search.getAttribute('data-tg-suggest-url');
		var timer = null;
		var pending = null;
		var lastQuery = null;

		function sync() {
			clear.hidden = input.value.length === 0;
		}

		function closeSuggest() {
			if (!panel) {
				return;
			}

			panel.hidden = true;
			panel.innerHTML = '';
			lastQuery = null;
		}

		function render(suggestions) {
			panel.innerHTML = '';

			if (!suggestions.length) {
				panel.hidden = true;
				return;
			}

			suggestions.forEach(function (suggestion) {
				var row = document.createElement('a');
				row.className = 'tg-search__suggest-item';
				row.href = suggestion.link;

				var image = document.createElement('img');
				image.className = 'tg-search__suggest-image';
				image.src = suggestion.image || '';
				image.alt = '';
				image.loading = 'lazy';
				// Produkt bez fotky nesmí nechat v řádku rozbitou ikonu.
				image.hidden = !suggestion.image;
				row.appendChild(image);

				var name = document.createElement('span');
				name.className = 'tg-search__suggest-name';
				name.textContent = suggestion.name;
				row.appendChild(name);

				var price = document.createElement('span');
				price.className = 'tg-search__suggest-price';
				price.textContent = suggestion.price;
				row.appendChild(price);

				panel.appendChild(row);
			});

			panel.hidden = false;
		}

		function request(query) {
			if (pending) {
				pending.abort();
			}

			pending = new AbortController();

			fetch(url + (url.indexOf('?') === -1 ? '?' : '&') + 'q=' + encodeURIComponent(query), {
				signal: pending.signal,
				headers: { 'X-Requested-With': 'XMLHttpRequest' },
				credentials: 'same-origin'
			})
				.then(function (response) {
					return response.ok ? response.json() : null;
				})
				.then(function (data) {
					// Mezitím mohl uživatel dopsat další znak, odpověď na starý dotaz zahodíme.
					if (!data || input.value.trim() !== query) {
						return;
					}

					lastQuery = query;
					render(data.suggestions || []);
				})
				.catch(function () {});
		}

		function scheduleSuggest() {
			if (!panel || !url) {
				return;
			}

			window.clearTimeout(timer);

			var query = input.value.trim();

			if (query.length < SUGGEST_MIN_LENGTH) {
				closeSuggest();
				return;
			}

			if (query === lastQuery) {
				return;
			}

			timer = window.setTimeout(function () {
				request(query);
			}, SUGGEST_DELAY);
		}

		input.addEventListener('input', function () {
			sync();
			scheduleSuggest();
		});

		// Návrat na pole s už napsaným textem nabídku zobrazí znovu.
		input.addEventListener('focus', scheduleSuggest);

		input.addEventListener('keydown', function (e) {
			if (e.key === 'Escape') {
				closeSuggest();
			} else if (e.key === 'Enter') {
				closeSuggest();
			}
		});

		clear.addEventListener('click', function () {
			input.value = '';
			sync();
			closeSuggest();
			input.focus();
		});

		// Klik mimo vyhledávací pole nabídku zavře.
		document.addEventListener('mousedown', function (e) {
			if (!search.contains(e.target)) {
				closeSuggest();
			}
		});

		sync();
	}

	// Banner carousel - autorotace, šipky, paginator, swipe.
	function initCarousel() {
		var carousel = document.querySelector('[data-tg-carousel]');

		if (!carousel) {
			return;
		}

		var slides = Array.prototype.slice.call(carousel.querySelectorAll('.tg-hero__slide'));

		if (slides.length < 2) {
			return;
		}

		var dotsBox = document.querySelector('[data-tg-carousel-dots]');
		var current = 0;
		var timer = null;
		var dots = [];

		// Boční bannery jsou snímky jen na úzkých displejích, na desktopu sedí vedle carouselu
		// a rotace by na nich skončila na prázdné ploše.
		function isRotatable(slide) {
			return window.getComputedStyle(slide).display !== 'none';
		}

		function rotatable() {
			return slides.filter(isRotatable);
		}

		function go(index) {
			var active = rotatable();

			if (!active.length) {
				return;
			}

			var position = ((index % active.length) + active.length) % active.length;
			current = slides.indexOf(active[position]);

			slides.forEach(function (slide, i) {
				slide.classList.toggle('is-active', i === current);
			});

			dots.forEach(function (dot, i) {
				dot.classList.toggle('is-active', i === current);
			});
		}

		function step(direction) {
			var active = rotatable();
			var position = active.indexOf(slides[current]);

			go(position + direction);
		}

		function start() {
			stop();
			timer = window.setInterval(function () {
				step(1);
			}, 6000);
		}

		function stop() {
			if (timer) {
				window.clearInterval(timer);
				timer = null;
			}
		}

		if (dotsBox) {
			slides.forEach(function (slide, i) {
				var dot = document.createElement('button');
				dot.type = 'button';
				// Tečky bočních bannerů patří k snímkům, které jsou na desktopu mimo carousel.
				dot.className = 'tg-hero__dot' + (slide.classList.contains('tg-hero__slide--side') ? ' tg-hero__dot--side' : '');
				dot.setAttribute('aria-label', 'Banner ' + (i + 1));
				dot.addEventListener('click', function () {
					go(rotatable().indexOf(slide));
					start();
				});
				dotsBox.appendChild(dot);
				dots.push(dot);
			});
		}

		var prev = carousel.querySelector('[data-tg-carousel-prev]');
		var next = carousel.querySelector('[data-tg-carousel-next]');

		if (prev) {
			prev.addEventListener('click', function () {
				step(-1);
				start();
			});
		}

		if (next) {
			next.addEventListener('click', function () {
				step(1);
				start();
			});
		}

		carousel.addEventListener('mouseenter', stop);
		carousel.addEventListener('mouseleave', start);

		// Swipe na dotykových zařízeních; svislé gesto necháváme stránce.
		var startX = null;

		carousel.addEventListener('touchstart', function (e) {
			startX = e.touches[0].clientX;
			stop();
		}, { passive: true });

		carousel.addEventListener('touchend', function (e) {
			if (startX === null) {
				return;
			}

			var delta = e.changedTouches[0].clientX - startX;

			if (Math.abs(delta) > 40) {
				step(delta < 0 ? 1 : -1);
			}

			startX = null;
			start();
		}, { passive: true });

		go(0);
		start();

		// Po změně šířky se mění i sada rotovaných snímků.
		window.addEventListener('resize', function () {
			if (!window.getComputedStyle(slides[current]).display || !isRotatable(slides[current])) {
				go(0);
			}
		});
	}

	// Galerie na detailu produktu - šipky cyklují dokola, náhledy i paginator vybírají přímo.
	function initGallery() {
		var stage = document.querySelector('[data-tg-gallery]');

		if (!stage) {
			return;
		}

		var photos = Array.prototype.slice.call(stage.querySelectorAll('[data-tg-gallery-photo]'));
		var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-tg-gallery-thumb]'));
		var dotsBox = document.querySelector('[data-tg-gallery-dots]');
		var dots = [];
		var current = 0;

		function go(index) {
			current = (index + photos.length) % photos.length;

			photos.forEach(function (photo, i) {
				photo.classList.toggle('is-active', i === current);
			});

			thumbs.forEach(function (thumb, i) {
				thumb.classList.toggle('is-active', i === current);
			});

			dots.forEach(function (dot, i) {
				dot.classList.toggle('is-active', i === current);
			});
		}

		if (dotsBox) {
			photos.forEach(function (photo, i) {
				var dot = document.createElement('button');
				dot.type = 'button';
				dot.className = 'tg-gallery__dot';
				dot.setAttribute('aria-label', 'Fotka ' + (i + 1));
				dot.addEventListener('click', function () {
					go(i);
				});
				dotsBox.appendChild(dot);
				dots.push(dot);
			});
		}

		thumbs.forEach(function (thumb, i) {
			thumb.addEventListener('click', function () {
				go(i);
			});
		});

		var prev = stage.querySelector('[data-tg-gallery-prev]');
		var next = stage.querySelector('[data-tg-gallery-next]');

		if (prev) {
			prev.addEventListener('click', function () {
				go(current - 1);
			});
		}

		if (next) {
			next.addEventListener('click', function () {
				go(current + 1);
			});
		}

		// Fullscreen prohlížení, pozadí se mezitím nesmí scrollovat.
		stage.addEventListener('click', function (e) {
			var photo = e.target.closest('[data-tg-gallery-photo]');

			if (!photo) {
				return;
			}

			var box = document.createElement('div');
			box.className = 'tg-lightbox';
			box.innerHTML = '<button type="button" class="tg-lightbox__close" aria-label="Zavřít">&times;</button><img src="' + photo.getAttribute('src') + '" alt="">';

			function close() {
				box.remove();
				document.body.style.overflow = '';
			}

			box.addEventListener('click', close);
			document.addEventListener('keydown', function onKey(ev) {
				if (ev.key === 'Escape') {
					close();
					document.removeEventListener('keydown', onKey);
				}
			});

			document.body.appendChild(box);
			document.body.style.overflow = 'hidden';
		});

		go(0);
	}

	// Taby na detailu produktu.
	function initTabs() {
		var tabs = Array.prototype.slice.call(document.querySelectorAll('[data-tg-tab]'));

		if (!tabs.length) {
			return;
		}

		var panels = Array.prototype.slice.call(document.querySelectorAll('[data-tg-panel]'));

		function open(name) {
			tabs.forEach(function (tab) {
				tab.classList.toggle('is-active', tab.getAttribute('data-tg-tab') === name);
			});

			panels.forEach(function (panel) {
				panel.classList.toggle('is-active', panel.getAttribute('data-tg-panel') === name);
			});
		}

		tabs.forEach(function (tab) {
			tab.addEventListener('click', function () {
				open(tab.getAttribute('data-tg-tab'));
			});
		});

		document.querySelectorAll('[data-tg-tab-link]').forEach(function (link) {
			link.addEventListener('click', function (e) {
				e.preventDefault();
				var name = link.getAttribute('data-tg-tab-link');
				open(name);
				document.querySelector('[data-tg-panel="' + name + '"]').scrollIntoView({ behavior: 'smooth', block: 'start' });
			});
		});
	}

	// Video na detailu produktu. Iframe se vkládá až po kliknutí, do té doby je vidět jen náhled.
	function initVideos() {
		document.querySelectorAll('[data-tg-video-play]').forEach(function (poster) {
			poster.addEventListener('click', function (e) {
				var src = poster.getAttribute('data-tg-video-play');

				// Bez referreru (offline, přísná politika) necháme proklik na YouTube v novém panelu.
				if (!src) {
					return;
				}

				e.preventDefault();

				var iframe = document.createElement('iframe');
				iframe.setAttribute('src', src);
				iframe.setAttribute('title', poster.getAttribute('aria-label') || '');
				iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
				iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
				iframe.setAttribute('allowfullscreen', 'true');

				poster.parentNode.replaceChild(iframe, poster);
			});
		});
	}

	// Detail produktu (přepnutí varianty) přichází AJAXem do snippetu, aby kvůli jiné barvě
	// neproblikla celá stránka. Adresu ani titulek nette.ajax.js nemění, o oboje se stará tohle.
	function initDetailAjax() {
		if (!window.jQuery || !window.jQuery.nette) {
			return;
		}

		window.jQuery.nette.ext('tgDetail', {
			success: function (payload, status, xhr, settings) {
				if (!payload.snippets || !payload.snippets['snippet--detail']) {
					return;
				}

				if (payload.title) {
					document.title = payload.title;
				}

				// Zpět a vpřed si adresu mění sám, jinak by v historii přibyl další záznam.
				if (settings.tgHistory !== false) {
					window.history.pushState({ tgDetail: true }, '', settings.url);
				}

				// Scroll zůstává, kde byl - odskok nahoru vypadá jako načtení nové stránky.
				initDetail();
			}
		});

		window.addEventListener('popstate', function () {
			if (!document.getElementById('snippet--detail')) {
				return;
			}

			window.jQuery.nette.ajax({ url: window.location.href, tgHistory: false });
		});
	}

	// Posluchače uvnitř detailu, po výměně snippetu se navěsí na nové prvky.
	function initDetail() {
		initGallery();
		initTabs();
		initVideos();
		initQuantity();
		initDetailTools();
		initStickyTitle();
		initTrack();
		initVariantSelect();
	}

	// Přepnutí varianty. Cíl je v hodnotě option, AJAXem se vymění jen snippet detailu.
	function initVariantSelect() {
		document.querySelectorAll('[data-tg-variant-select]').forEach(function (select) {
			select.addEventListener('change', function () {
				if (!select.value) {
					return;
				}

				if (window.jQuery && window.jQuery.nette) {
					window.jQuery.nette.ajax({ url: select.value });
					return;
				}

				window.location.assign(select.value);
			});
		});
	}

	// Počet kusů na detailu, tlačítka +/- nad běžným inputem.
	function initQuantity() {
		document.querySelectorAll('.tg-qty').forEach(function (box) {
			var input = box.querySelector('.tg-qty__input');

			if (!input) {
				return;
			}

			box.querySelectorAll('[data-tg-qty]').forEach(function (button) {
				button.addEventListener('click', function () {
					var step = parseInt(button.getAttribute('data-tg-qty'), 10);
					var value = parseInt(input.value, 10);

					if (isNaN(value)) {
						value = 1;
					}

					input.value = Math.max(1, value + step);
					input.dispatchEvent(new Event('change', { bubbles: true }));
				});
			});
		});
	}

	// Sdílení a tisk.
	function initDetailTools() {
		var share = document.querySelector('[data-tg-share]');

		if (share) {
			share.addEventListener('click', function () {
				var tip = document.querySelector('[data-tg-share-tip]');

				function confirmCopy() {
					if (!tip) {
						return;
					}

					tip.hidden = false;
					window.setTimeout(function () {
						tip.hidden = true;
					}, 2000);
				}

				if (navigator.clipboard) {
					navigator.clipboard.writeText(window.location.href).then(confirmCopy, function () {});
				} else {
					confirmCopy();
				}
			});
		}

		var print = document.querySelector('[data-tg-print]');

		if (print) {
			print.addEventListener('click', function () {
				window.print();
			});
		}
	}

	// Lišta s názvem produktu vyjede, jakmile hlavní nadpis odscrolluje nad okraj. Hlídá se
	// pozorovatelem, ne posluchačem na scrollu - Safari ho volá opožděně a lišta se cukala.
	var stickyTitleObserver = null;

	function initStickyTitle() {
		var sticky = document.querySelector('[data-tg-sticky-title]');
		var title = document.querySelector('.tg-detail__title');

		if (stickyTitleObserver) {
			stickyTitleObserver.disconnect();
			stickyTitleObserver = null;
		}

		if (!sticky || !title || !window.IntersectionObserver) {
			return;
		}

		// Schovaná je posunem, aby mohla vyjet - atribut hidden drží lištu jen do načtení JS.
		sticky.hidden = false;

		stickyTitleObserver = new IntersectionObserver(function (entries) {
			sticky.classList.toggle('is-visible', entries[0].boundingClientRect.bottom <= 0);
		});

		stickyTitleObserver.observe(title);
	}

	// Karusel souvisejících produktů - posouvá se po celých kartách, na dotyku swipe. Posluchač
	// na okně visí jen jednou, po výměně detailu se mu jen podstrčí nový karusel.
	var trackResizeBound = false;
	var trackSync = null;

	function initTrack() {
		var viewport = document.querySelector('[data-tg-track]');

		if (!viewport) {
			return;
		}

		var track = viewport.querySelector('[data-tg-track-scroller]');
		var cell = track.querySelector('.tg-related__cell');
		var prev = viewport.querySelector('[data-tg-track-prev]');
		var next = viewport.querySelector('[data-tg-track-next]');

		if (!cell) {
			return;
		}

		// Posouvá se nativním scrollem po celých kartách, swipe tak funguje sám od sebe.
		function step(direction) {
			track.scrollBy({ left: direction * cell.offsetWidth, behavior: 'smooth' });
		}

		function sync() {
			var atStart = track.scrollLeft <= 1;
			var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;

			if (prev) {
				prev.classList.toggle('is-available', !atStart);
			}

			if (next) {
				next.classList.toggle('is-available', !atEnd);
			}
		}

		if (prev) {
			prev.addEventListener('click', function () {
				step(-1);
			});
		}

		if (next) {
			next.addEventListener('click', function () {
				step(1);
			});
		}

		track.addEventListener('scroll', sync, { passive: true });
		trackSync = sync;

		if (!trackResizeBound) {
			trackResizeBound = true;
			window.addEventListener('resize', function () {
				if (trackSync) {
					trackSync();
				}
			});
		}

		sync();
	}

	// Potvrzovací modály (do košíku, do porovnání). Přicházejí AJAXem do snippetu,
	// proto se na ně věší delegovaný posluchač a zámek scrollu se hlídá pozorovatelem.
	function initModals() {
		function close() {
			document.querySelectorAll('[data-tg-modal]').forEach(function (modal) {
				modal.remove();
			});
			document.body.classList.remove('body--modal');
		}

		document.addEventListener('click', function (e) {
			if (e.target.closest('[data-tg-modal-close]')) {
				close();
				return;
			}

			// Kliknutí na tmavé pozadí zavírá, uvnitř panelu ne.
			var modal = e.target.closest('[data-tg-modal]');

			if (modal && !e.target.closest('.tg-modal__panel')) {
				close();
			}
		});

		document.addEventListener('keydown', function (e) {
			if (e.key === 'Escape') {
				close();
			}
		});

		new MutationObserver(function () {
			document.body.classList.toggle('body--modal', !!document.querySelector('[data-tg-modal], [data-tg-auth-modal]'));
		}).observe(document.body, { childList: true, subtree: true });
	}

	// Okno s přihlášením a registrací. Panely jsou v DOMu všechny, přepínají se tady;
	// zavírá se proklikem na signál, aby zůstal v souladu i stav na serveru.
	function initAuthModal() {
		function focusFirstField() {
			var field = document.querySelector('[data-tg-auth-panel].is-active input:not([type="hidden"]):not([type="checkbox"])');

			if (field) {
				field.focus();
			}
		}

		function show(name) {
			document.querySelectorAll('[data-tg-auth-panel]').forEach(function (panel) {
				panel.classList.toggle('is-active', panel.getAttribute('data-tg-auth-panel') === name);
			});

			focusFirstField();
		}

		function close() {
			var link = document.querySelector('[data-tg-auth-close]');

			if (link) {
				link.click();
			}
		}

		document.addEventListener('click', function (e) {
			var trigger = e.target.closest('[data-tg-auth-switch]');

			if (trigger) {
				show(trigger.getAttribute('data-tg-auth-switch'));
				return;
			}

			// Kliknutí na tmavé pozadí zavírá, uvnitř panelu ne.
			var modal = e.target.closest('[data-tg-auth-modal]');

			if (modal && !e.target.closest('.tg-auth__panel')) {
				e.preventDefault();
				close();
			}
		});

		document.addEventListener('keydown', function (e) {
			if (e.key === 'Escape' && document.querySelector('[data-tg-auth-modal]')) {
				close();
			}
		});

		var opened = false;

		new MutationObserver(function () {
			var isOpen = !!document.querySelector('[data-tg-auth-modal]');

			if (isOpen && !opened) {
				focusFirstField();
			}

			opened = isOpen;
		}).observe(document.body, { childList: true, subtree: true });

		focusFirstField();
	}

	// Náhled košíku pod tlačítkem v hlavičce, klik mimo ho zavře.
	function initCartPreview() {
		document.addEventListener('click', function (e) {
			var preview = document.querySelector('[data-tg-cart-preview]');

			if (!preview) {
				return;
			}

			var toggle = e.target.closest('[data-tg-cart-toggle]');

			if (toggle) {
				e.preventDefault();
				preview.hidden = !preview.hidden;
				return;
			}

			if (e.target.closest('[data-tg-cart-close]')) {
				preview.hidden = true;
				return;
			}

			// Kliknutí uvnitř náhledu (změna kusů, odebrání) ho nezavírá.
			if (!e.target.closest('[data-tg-cart-box]')) {
				preview.hidden = true;
			}
		});
	}

	// Přepínač zákaznická / firemní registrace přehazuje checkbox "nákup na firmu".
	// Registrace bydlí i v okně, které přichází AJAXem, proto se přepínače hledají opakovaně.
	function initRegSwitch() {
		function setup(box) {
			if (box.dataset.tgRegswitchReady) {
				return;
			}

			// Checkbox patří formuláři vedle přepínače. Stejně pojmenovaný má i objednávkový
			// formulář, nad kterým se okno může otevřít, proto hledáme jen ve společném rodiči.
			var checkbox = box.parentElement.querySelector('input[name="businessPurchase"]');

			if (!checkbox) {
				box.hidden = true;
				return;
			}

			box.dataset.tgRegswitchReady = '1';

			var options = Array.prototype.slice.call(box.querySelectorAll('[data-tg-regswitch-value]'));

			function sync() {
				var value = checkbox.checked ? '1' : '0';

				options.forEach(function (option) {
					option.classList.toggle('is-active', option.getAttribute('data-tg-regswitch-value') === value);
				});
			}

			options.forEach(function (option) {
				option.addEventListener('click', function () {
					checkbox.checked = option.getAttribute('data-tg-regswitch-value') === '1';
					checkbox.dispatchEvent(new Event('change', { bubbles: true }));
					sync();
				});
			});

			// Původní checkbox se skryje, přepínač ho zastupuje.
			var wrapper = checkbox.closest('.form-check') || checkbox.parentElement;

			if (wrapper) {
				wrapper.hidden = true;
			}

			sync();
		}

		function scan() {
			document.querySelectorAll('[data-tg-regswitch]').forEach(setup);
		}

		scan();

		new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
	}

	// Poradce - otevření okna, taby a zastavení bubliny nad patičkou.
	function initAdvisor() {
		var advisor = document.querySelector('[data-tg-advisor]');

		if (!advisor) {
			return;
		}

		var win = advisor.querySelector('[data-tg-advisor-window]');
		var online = advisor.querySelector('[data-tg-advisor-online]');
		var panels = Array.prototype.slice.call(advisor.querySelectorAll('[data-tg-advisor-panel]'));
		var tabs = Array.prototype.slice.call(advisor.querySelectorAll('[data-tg-advisor-tab]'));

		function openTab(name) {
			tabs.forEach(function (tab) {
				tab.classList.toggle('is-active', tab.getAttribute('data-tg-advisor-tab') === name && tab.classList.contains('tg-advisor__mode-opt'));
			});

			panels.forEach(function (panel) {
				panel.classList.toggle('is-active', panel.getAttribute('data-tg-advisor-panel') === name);
			});

			// Badge ONLINE patří jen k AI chatu.
			if (online) {
				online.hidden = name !== 'chat';
			}
		}

		tabs.forEach(function (tab) {
			tab.addEventListener('click', function () {
				openTab(tab.getAttribute('data-tg-advisor-tab'));
			});
		});

		var bubble = advisor.querySelector('[data-tg-advisor-toggle]');

		// Otevřené okno bublinu nahrazuje, jinak by se překrývaly.
		function toggleWindow(open) {
			win.hidden = !open;
			bubble.hidden = open;
		}

		bubble.addEventListener('click', function () {
			toggleWindow(win.hidden);
		});

		advisor.querySelectorAll('[data-tg-advisor-close]').forEach(function (btn) {
			btn.addEventListener('click', function () {
				toggleWindow(false);
			});
		});

		// Nabídnutý dotaz zatím nemá AI, kam by šel - přepne na formulář a předvyplní ho.
		advisor.querySelectorAll('[data-tg-advisor-starter]').forEach(function (btn) {
			btn.addEventListener('click', function () {
				openTab('message');

				var field = win.querySelector('textarea[name="message"]');

				if (field) {
					field.value = btn.getAttribute('data-tg-advisor-starter');
					field.focus();
				}
			});
		});

		// Bublina se zastaví nad patičkou, ať ji nepřekrývá.
		var footer = document.querySelector('.tg-footer');

		if (footer) {
			window.addEventListener('scroll', function () {
				var overlap = window.innerHeight - footer.getBoundingClientRect().top;
				advisor.style.transform = overlap > 0 ? 'translateY(' + -overlap + 'px)' : '';
			}, { passive: true });
		}

		// Formulář po odeslání zprávy zůstane otevřený na svém tabu.
		if (window.location.hash === '#advisor-sent') {
			toggleWindow(true);
			openTab('message');
		}

		// "Zeptat se" a "Na dotaz" otevřou poradce s předvyplněným dotazem na produkt.
		document.addEventListener('click', function (e) {
			var trigger = e.target.closest('[data-tg-ask]');

			if (!trigger) {
				return;
			}

			e.preventDefault();
			toggleWindow(true);
			openTab('message');

			var field = win.querySelector('textarea[name="message"]');

			if (field && !field.value.trim()) {
				field.value = 'Chci poradit s produktem ' + trigger.getAttribute('data-tg-ask') + '. ';
			}

			if (field) {
				field.focus();
				field.setSelectionRange(field.value.length, field.value.length);
			}
		});
	}

	// Nezlomitelné mezery. Jednopísmenné a krátké předložky, jednotky a tisícové skupiny se nesmí
	// odtrhnout - bez toho se texty lámou jinak než v prototypu (nejvíc je to vidět na kategoriích).
	var NBSP = ' ';
	var NBSP_ONE = /([\s (\[„"'>–—-])([aikosuvzAIKOSUVZ]) /g;
	var NBSP_TWO = /([\s (\[„"'>–—-])(na|do|po|za|od|ze|ke|ku|ve|se|Na|Do|Po|Za|Od|Ze|Ke|Ku|Ve|Se) /g;
	var NBSP_UNIT = /(\d) (Kč|kg|g|l|ml|ks|mm|cm|m²|m|MPa|GPa|%|°C|minut|min|hodin|hod|dní|dnů|let|roky?|balení)/g;
	var NBSP_GROUP = /(\d) (\d{3})(?!\d)/g;

	function fixNbsp(node) {
		var value = node.nodeValue;

		if (!value || value.length < 3 || value.indexOf(' ') === -1) {
			return;
		}

		var fixed = value
			.replace(NBSP_ONE, '$1$2' + NBSP).replace(NBSP_ONE, '$1$2' + NBSP)
			.replace(NBSP_TWO, '$1$2' + NBSP)
			.replace(NBSP_UNIT, '$1' + NBSP + '$2')
			.replace(NBSP_GROUP, '$1' + NBSP + '$2')
			.replace(/^([aikosuvzAIKOSUVZ]) /, '$1' + NBSP)
			.replace(/^(Na|Do|Po|Za|Od|Ze|Ke|Ku|Ve|Se|na|do|po|za|od|ze|ke|ku|ve|se) /, '$1' + NBSP);

		if (fixed !== value) {
			node.nodeValue = fixed;
		}
	}

	function initNbsp() {
		var walk = function () {
			var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
				acceptNode: function (node) {
					var parent = node.parentNode && node.parentNode.nodeName;

					return (parent === 'SCRIPT' || parent === 'STYLE' || parent === 'TEXTAREA' || parent === 'INPUT')
						? NodeFilter.FILTER_REJECT
						: NodeFilter.FILTER_ACCEPT;
				}
			});

			var node;

			while ((node = walker.nextNode())) {
				fixNbsp(node);
			}
		};

		// Vlastní úpravy textu spouštějí pozorovatele znovu, proto se na dobu průchodu odpojuje.
		var scheduled = false;
		var observer = new MutationObserver(function () {
			if (scheduled) {
				return;
			}

			scheduled = true;
			requestAnimationFrame(function () {
				scheduled = false;
				observer.disconnect();
				walk();
				observe();
			});
		});

		function observe() {
			observer.observe(document.body, { childList: true, subtree: true, characterData: true });
		}

		walk();
		observe();
	}

	// Na mobilu se placeholder vyhledávání zkracuje, aby se vešel do zúženého pole.
	function initSearchPlaceholder() {
		var query = window.matchMedia('(max-width: ' + 760 + 'px)');

		function apply() {
			var input = document.querySelector('.tg-search__input');

			if (!input) {
				return;
			}

			if (!input.dataset.placeholderFull) {
				input.dataset.placeholderFull = input.placeholder || '';
			}

			input.placeholder = query.matches
				? (input.dataset.placeholderShort || input.dataset.placeholderFull)
				: input.dataset.placeholderFull;
		}

		if (query.addEventListener) {
			query.addEventListener('change', apply);
		} else {
			query.addListener(apply);
		}

		apply();
	}

	// Odkud se uživatel do košíku dostal - drobečky i "Odejít z košíku" míří sem.
	var CART_FROM_KEY = 'tgCartFrom';

	function cartFrom() {
		try {
			return JSON.parse(sessionStorage.getItem(CART_FROM_KEY)) || null;
		} catch (e) {
			return null;
		}
	}

	function initCartFrom() {
		var crumbsBox = document.querySelector('.tg-breadcrumbs__inner');

		if (document.querySelector('[data-tg-checkout]')) {
			restoreCartCrumbs(crumbsBox);
			return;
		}

		var crumbs = [];

		if (crumbsBox) {
			[].forEach.call(crumbsBox.querySelectorAll('a, .tg-breadcrumbs__current'), function (el, i) {
				if (i === 0) {
					return;
				}

				crumbs.push({
					label: el.textContent.trim(),
					url: el.getAttribute('href') || window.location.href
				});
			});
		}

		try {
			sessionStorage.setItem(CART_FROM_KEY, JSON.stringify({ url: window.location.href, crumbs: crumbs }));
		} catch (e) {}
	}

	function restoreCartCrumbs(box) {
		var from = cartFrom();

		if (!box || !from || !from.crumbs || !from.crumbs.length) {
			return;
		}

		var current = box.querySelector('.tg-breadcrumbs__current');
		var separator = current && current.previousElementSibling;

		if (!separator) {
			return;
		}

		from.crumbs.forEach(function (crumb) {
			var sep = document.createElement('span');
			sep.className = 'tg-breadcrumbs__sep';
			sep.setAttribute('aria-hidden', 'true');
			sep.innerHTML = '&rsaquo;';

			var link = document.createElement('a');
			link.href = crumb.url;
			link.textContent = crumb.label;

			box.insertBefore(sep, separator);
			box.insertBefore(link, separator);
		});
	}

	// Košík ve třech krocích. Server o kroku neví, přepíná se `data-step` a zbytek řeší CSS,
	// pole kroku 2 proto musíme ohlídat klientsky.
	function initCheckout() {
		var cart = document.querySelector('[data-tg-checkout]');

		if (!cart) {
			return;
		}

		var pendingStep = null;
		var checkInvalid = false;

		function current() {
			return parseInt(cart.getAttribute('data-step'), 10) || 1;
		}

		// select2 kreslí rámeček na svůj box, ne na skrytém selectu
		function select2Box(elem) {
			if (elem.tagName !== 'SELECT') {
				return null;
			}

			var box = elem.nextElementSibling;

			return box && box.classList && box.classList.contains('select2-container')
				? box.querySelector('.select2-selection')
				: null;
		}

		function setMissing(elem, on) {
			elem.classList.toggle('tg-missing', on);

			var box = select2Box(elem);

			if (box) {
				box.classList.toggle('tg-missing', on);
			}
		}

		// Radio skupinu bereme jednou, ale až po vyřazení zakázaných - jinak by zakázaná
		// první doprava umlčela celou skupinu.
		function step2Controls() {
			var controls = [];
			var radios = {};

			[].forEach.call(cart.querySelectorAll('.tg-co--contact, .tg-co--delivery'), function (section) {
				[].forEach.call(section.querySelectorAll('input, select, textarea'), function (elem) {
					if (!elem.name || !window.Nette || window.Nette.isDisabled(elem)) {
						return;
					}

					if (elem.type === 'radio') {
						if (radios[elem.name]) {
							return;
						}

						radios[elem.name] = true;
					}

					controls.push(elem);
				});
			});

			return controls;
		}

		function isStep2Valid() {
			if (!window.Nette) {
				return true;
			}

			return step2Controls().every(function (elem) {
				// onlyCheck: jen vrátí platnost, nic nevypisuje
				return window.Nette.validateControl(elem, null, true);
			});
		}

		function refreshCta() {
			var cta = cart.querySelector('.tg-summary__cta--2');

			if (cta) {
				cta.classList.toggle('is-disabled', !isStep2Valid());
			}
		}

		function showError(message) {
			var box = cart.querySelector('[data-tg-step-error]');

			if (!box) {
				return;
			}

			box.textContent = message || box.getAttribute('data-tg-step-error-default') || '';
			box.hidden = false;
		}

		function hideError() {
			var box = cart.querySelector('[data-tg-step-error]');

			if (box) {
				box.hidden = true;
			}
		}

		function markMissing() {
			var controls = step2Controls();
			var first = null;

			controls.forEach(function (elem) {
				var valid = window.Nette ? window.Nette.validateControl(elem, null, true) : true;

				setMissing(elem, !valid);

				if (!valid && !first) {
					first = elem;
				}
			});

			return first;
		}

		function scrollTo(elem) {
			if (!elem) {
				return;
			}

			var target = select2Box(elem) || elem;
			var box = (target.closest && target.closest('.row, .mb-3, .form-group, .tg-cart-card')) || target;

			box.scrollIntoView({ behavior: 'smooth', block: 'center' });
		}

		// DIČ umí ověřit jen server (VIES), do kroku 3 pustí až jeho odpověď
		function needsVatinCheck() {
			var vatPayer = cart.querySelector('[name="vatPayer"]');
			var vatin = cart.querySelector('[name="vatin"]');

			return !!(
				window.jQuery
				&& cart.querySelector('.js-checkVatin')
				&& vatPayer && vatPayer.checked
				&& vatin && vatin.value.trim()
			);
		}

		function vatinErrors(payload) {
			var snippet = payload && payload.snippets && payload.snippets['snippet-frm-newOrderForm-form-vatin-errors'];

			if (!snippet) {
				return [];
			}

			var box = document.createElement('div');
			box.innerHTML = snippet;

			// snippet nese i skript, bereme jen hlášky
			return [].map.call(box.querySelectorAll('.js-error'), function (el) {
				return el.textContent.trim();
			}).filter(Boolean);
		}

		function enterStep(step) {
			cart.setAttribute('data-step', String(step));
			hideError();
			apply();
			window.scrollTo({ top: 0, behavior: 'smooth' });
		}

		function tryEnterStep(step) {
			if (step < 3) {
				enterStep(step);
				return;
			}

			if (!isStep2Valid()) {
				showError();
				scrollTo(markMissing());
				return;
			}

			if (needsVatinCheck()) {
				pendingStep = 3;
				window.jQuery(cart.querySelector('.js-checkVatin')).click();
				return;
			}

			enterStep(3);
		}

		// Server označí pole z kroku 2, ale odesílá se z kroku 3 - bez přepnutí by chybu nikdo neviděl.
		function revealInvalid() {
			var invalid = cart.querySelector('.tg-co--contact .is-invalid, .tg-co--delivery .is-invalid');

			if (!invalid) {
				return;
			}

			if (current() !== 2) {
				cart.setAttribute('data-step', '2');
				apply();
			}

			setMissing(invalid, true);
			showError();
			scrollTo(invalid);
		}

		function apply() {
			var step = current();

			[].forEach.call(cart.querySelectorAll('.tg-steps__item'), function (item, i) {
				var n = i + 1;

				item.classList.toggle('is-done', n < step);
				item.classList.toggle('is-current', n === step);
			});

			if (step === 2) {
				refreshCta();
			}
		}

		document.addEventListener('click', function (e) {
			if (!e.target.closest) {
				return;
			}

			var next = e.target.closest('[data-tg-step-next]');

			if (next) {
				e.preventDefault();
				tryEnterStep(parseInt(next.getAttribute('data-tg-step-next'), 10));
				return;
			}

			var back = e.target.closest('[data-tg-step-goto]');

			if (back) {
				e.preventDefault();
				enterStep(parseInt(back.getAttribute('data-tg-step-goto'), 10));
				return;
			}

			var stepLink = e.target.closest('.tg-steps__item');

			if (stepLink) {
				e.preventDefault();

				// zpět jen na hotový krok, dopředu vede tlačítko v souhrnu
				if (stepLink.classList.contains('is-done')) {
					tryEnterStep(parseInt(stepLink.getAttribute('data-tg-step'), 10));
				}

				return;
			}

			var leave = e.target.closest('[data-tg-cart-leave]');
			var from = leave && cartFrom();

			if (from && from.url) {
				e.preventDefault();
				window.location.href = from.url;
			}
		});

		// Plátce DPH sedí uvnitř firemního bloku, takže s ním musí i zmizet. Zaškrtnutý ve skrytém
		// poli by držel vatin povinný a server by objednávku odmítl - showPriceWithoutVat() počítá
		// i s firemním nákupem. Odbavujeme v capture fázi, ať sdílený skript odešle už nový stav.
		document.addEventListener('click', function (e) {
			var purchase = e.target.closest && e.target.closest('[name="businessPurchase"]');

			if (!purchase || purchase.checked || !cart.contains(purchase)) {
				return;
			}

			var vatPayer = cart.querySelector('[name="vatPayer"]');

			if (vatPayer && vatPayer.checked) {
				vatPayer.checked = false;
			}
		}, true);

		function live(e) {
			if (current() !== 2 || !e.target || !e.target.name) {
				return;
			}

			if (e.target.closest && (e.target.closest('.tg-co--contact') || e.target.closest('.tg-co--delivery'))) {
				setMissing(e.target, false);
				hideError();
			}

			refreshCta();
		}

		document.addEventListener('input', live, true);
		document.addEventListener('change', live, true);

		if (window.jQuery) {
			window.jQuery(document).ajaxSuccess(function (e, xhr, settings) {
				var el = settings && settings.nette && settings.nette.el;

				if (el && window.jQuery(el).is('.orderForm-submit')) {
					checkInvalid = true;
				}

				var messages = vatinErrors(xhr.responseJSON);

				if (pendingStep && messages.length) {
					pendingStep = null;
					showError(messages.join(' '));
					scrollTo(cart.querySelector('[name="vatin"]'));
					return;
				}

				if (pendingStep) {
					var step = pendingStep;
					pendingStep = null;
					enterStep(step);
				}
			});

			// po překreslení souhrnu je tlačítko nové, stav kroku se musí vrátit
			window.jQuery(document).ajaxComplete(function () {
				apply();

				if (checkInvalid) {
					checkInvalid = false;
					revealInvalid();
				}
			});
		}

		apply();
	}

	// Voucher je podkomponenta objednávky, nedá se vnořit do jejího <form> - posíláme signál sami.
	function initVoucher() {
		function submit() {
			var input = document.getElementById('frm-newOrderForm-voucherUseForm-form-voucher');

			if (!input || !window.jQuery || !window.jQuery.nette) {
				return;
			}

			window.jQuery.nette.ajax({
				url: window.location.href,
				type: 'POST',
				data: {
					voucher: input.value,
					'_do': 'newOrderForm-voucherUseForm-form-submit',
					'_submit': ''
				}
			});
		}

		document.addEventListener('click', function (e) {
			if (e.target.closest && e.target.closest('#voucherUseButton')) {
				e.preventDefault();
				submit();
			}
		});

		document.addEventListener('keydown', function (e) {
			if (e.key === 'Enter' && e.target && e.target.id === 'frm-newOrderForm-voucherUseForm-form-voucher') {
				e.preventDefault();
				submit();
			}
		});
	}

	/**
	 * Oznámení: úspěch a informace zmizí samy, chyba a varování až po zavření.
	 * Nové zprávy přichází i AJAXem, proto se plánuje skrytí přes MutationObserver.
	 */
	function initFlashes() {
		function hide(flash) {
			flash.classList.add('is-leaving');
			setTimeout(function () {
				var wrapper = flash.parentElement;
				flash.remove();

				if (wrapper && !wrapper.children.length) {
					wrapper.remove();
				}
			}, 200);
		}

		function schedule(root) {
			root.querySelectorAll('[data-tg-flash="success"]:not([data-scheduled]), [data-tg-flash="info"]:not([data-scheduled])').forEach(function (flash) {
				flash.setAttribute('data-scheduled', '');
				setTimeout(function () { hide(flash); }, 6000);
			});
		}

		document.addEventListener('click', function (e) {
			var button = e.target.closest('[data-tg-flash-close]');

			if (button) {
				hide(button.closest('[data-tg-flash]'));
			}
		});

		var snippet = document.getElementById('snippet--flashes');

		if (snippet) {
			schedule(snippet);
			new MutationObserver(function () { schedule(snippet); }).observe(snippet, { childList: true, subtree: true });
		}
	}

	document.addEventListener('DOMContentLoaded', function () {
		initFlashes();
		initModals();
		initAuthModal();
		initAdvisor();
		initRegSwitch();
		initCartPreview();
		initSearch();
		initCarousel();
		initDetailAjax();
		initDetail();
		initCartFrom();
		initCheckout();
		initVoucher();
		initSearchPlaceholder();
		initNbsp();
	});
})();
